import { Modal } from '@maxtropy/components';
import {
  apiV2PipelineLossProcessDataPost,
  apiV2PipelineLossProcessDeviceInfoPost,
  V2PipelineLossProcessDeviceInfoPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { useEffect, useState } from 'react';
import DMYDateSwitch from '../components/DMYDateSwitch';
import { Dayjs } from 'dayjs';
import { useRequest } from 'ahooks';
import WaterChart from '../components/PipeLosChart';
import { ModalType } from '../components/DMYDateSwitch/type';
import styles from './index.module.scss';
import { isEmpty } from 'lodash-es';
interface PipeLossDetailProps {
  onCancel?: () => void;
  pipeLossId?: string;
}
const PipeLossDetail: React.FC<PipeLossDetailProps> = ({ onCancel, pipeLossId }) => {
  const [rangeDate, setRangeDate] = useState<[Dayjs, Dayjs] | null>(null);
  const [activeKey, setActiveKey] = useState<'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'YEAR'>('DAY');
  const [deviceList, setDeviceList] = useState<V2PipelineLossProcessDeviceInfoPostResponse>();
  const { data: pipeLossChartData, loading } = useRequest(
    () => {
      // 管损图表数据
      return apiV2PipelineLossProcessDataPost({
        from: rangeDate ? rangeDate[0].valueOf() : undefined,
        to: rangeDate ? rangeDate[1].endOf('day').valueOf() : undefined,
        id: pipeLossId,
        type: activeKey[0],
      });
    },
    {
      refreshDeps: [rangeDate, pipeLossId, activeKey],
      ready: !!pipeLossId && !!rangeDate,
      defaultParams: [],
    }
  );

  useEffect(() => {
    // 获取管损对应设备信息
    apiV2PipelineLossProcessDeviceInfoPost({ id: pipeLossId }).then(res => {
      setDeviceList(res || []);
    });
  }, [pipeLossId, rangeDate]);
  return (
    <>
      <Modal
        open={true}
        size="big"
        maskClosable={false}
        onCancel={onCancel}
        destroyOnClose
        footer={null}
        title={
          <div className={styles.modalTitle}>
            <span>查看详情</span>
            <span
              className={styles.moreLink}
              onClick={e => {
                e.stopPropagation();
                window.open('/energyMedia/topology/analysis', '_blank');
              }}
            >
              更多&nbsp;{'>>'}
            </span>
          </div>
        }
      >
        <div className={styles.deviceInfoBox}>
          <div className={styles.titleLabel}>
            拓扑节点输入对应设备：
            <span className={styles.titleValue}>
              {isEmpty(deviceList?.entry) ? '--' : deviceList?.entry?.map(item => item.name).join('、')}
            </span>
          </div>
          <div className={styles.titleLabel}>
            拓扑节点输出对应设备：
            <span className={styles.titleValue}>
              {isEmpty(deviceList?.exit) ? '--' : deviceList?.exit?.map(item => item.name).join('、')}
            </span>
          </div>
        </div>
        <DMYDateSwitch
          onRangeDateChange={setRangeDate}
          onActiveKeyChange={setActiveKey}
          switchOption={ModalType.PipeLoss}
        />
        {/* <div className={styles.lossValueBox}>
          <div className={styles.LossValue}>
            管损量：
            <span className={styles.LossRate}>--</span>
          </div>
          <div className={styles.LossValue}>
            管损率：
            <span className={styles.LossRate}>--</span>
          </div>
        </div> */}
        <WaterChart data={pipeLossChartData} activeKey={activeKey} />
      </Modal>
    </>
  );
};

export default PipeLossDetail;
